<nz-card>
  <nz-spin [nzSpinning]="loading">

    <div style="width: 100%;">
      <div>
        <form nz-form [formGroup]="validateForm">
          <div nz-row>
            <div nz-col style="width:21%">
              <nz-form-item>
                <nz-form-label>
                  <div class="width-100-percent label-font">{{ "ProxyID" | translate}}
                  </div>
                </nz-form-label>
                <nz-form-control>
                  <nz-select [nzServerSearch]="true" formControlName="proxyId" (nzOnSearch)="userSearch($event)"
                    style="border-radius:6px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
                    [nzShowSearch]="true">
                    <nz-option *ngFor="let o of userOptionList" [nzValue]="o.userId"
                      nzLabel="{{o.userId}}/{{o.englishName}}" nzCustomContent>
                      <span>{{o.userId}}/{{o.englishName}}</span>
                    </nz-option>
                  </nz-select>
                </nz-form-control>
              </nz-form-item>
            </div>
            <div nz-col nzSpan="1"></div>
            <div nz-col nzSpan="1" class="width-100-percent">
              <button nz-button class="default-button" nzType="primary" (click)="onSearch()"><span nz-icon
                  nzType="search" nzTheme="outline"></span>{{ "Query" | translate}}</button>
            </div>
          </div>

        </form>
        <strong class="margin-left-8 result">{{ "ProxyInformation" | translate}}</strong>
      </div>


      <!-- <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
      [nzFrontPagination]="false" [nzShowPagination]="false" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
      [nzScroll]="{ y: '500px', x: '1400px' }" >
      <thead>
        <tr>
          <th scope="col" nzWidth="50px">{{ "act" | translate}}</th>
          <th scope="col" nzWidth="50px">{{ "ProxyFunction" | translate }}</th>
          <th scope="col" nzWidth="100px">{{ "EmployeeID" | translate }}</th>
          <th scope="col" nzWidth="50px">{{ "EmployeeName" | translate }}</th>
          <th scope="col" nzWidth="100px">{{ "ProxyID" | translate }}</th>
          <th scope="col" nzWidth="50px">{{ "ProxyName" | translate }}</th>
          <th scope="col" nzWidth="50px">{{ "DateFrom" | translate }}</th>
          <th scope="col" nzWidth="50px">{{ "EndDate" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of colSpanTable.data; let i = index">
          <td><img src="../../../assets/image/img_edit.png" [alt]="'Button.Update'|translate" (click)="onEdit(data)" class="pointer"></td>
          <td></td>
          <td>{{data.employeeID}}</td>
          <td>{{data.employeeName}}</td>
          <td>{{data.proxyID}}</td>
          <td>{{data.proxyName}}</td>
          <td>{{data.startDate}}</td>
          <td>{{data.endDate}}</td>
        </tr>
      </tbody>
    </nz-table>
    <nz-pagination style="float: right" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
      nzShowSizeChanger [nzPageSizeOptions]="[10, 15, 20]" [nzPageSize]="pageSize"
      (nzPageSizeChange)="nzPageSizeChange($event)" nzShowQuickJumper (nzPageIndexChange)="nzPageIndexChange($event)">
    </nz-pagination> -->
    </div>

    <!-- <app-add-edit-changeproxy *ngIf="isEdit" [isEdit]="true" [editData]="editData" (close)="closeAdd()" (save)="saveEdit($event)"></app-add-edit-changeproxy> -->


    <nz-table #editRowTable [nzData]="listOfData" nzTableLayout="fixed">
      <thead>
        <tr>
          <th scope="col" nzWidth="100px">{{ "EmployeeID" | translate }}</th>
          <th scope="col" nzWidth="50px">{{ "EmployeeName" | translate }}</th>
          <th scope="col" nzWidth="100px">{{ "ProxyID" | translate }}</th>
          <th scope="col" nzWidth="50px">{{ "ProxyName" | translate }}</th>
          <th scope="col" nzWidth="50px">{{ "DateFrom" | translate }}</th>
          <th scope="col" nzWidth="50px">{{ "EndDate" | translate }}</th>
          <th scope="col" nzWidth="50px" [nzRight]="true">{{ "act" | translate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of editRowTable.data">
          <ng-container *ngIf="!editCache[data.sid].edit; else editTemplate">
            <td>{{data.employeeID}}</td>
            <td>{{data.employeeName}}</td>
            <td>{{data.proxyID}}</td>
            <td>{{data.proxyName}}</td>
            <td>{{data.startDate}}</td>
            <td>{{data.endDate}}</td>
            <td [nzRight]="true" style="align-content: center;"><span nz-icon nzType="edit" nzTheme="outline"
                (click)="startEdit(data.sid)"></span> </td>
          </ng-container>
          <ng-template #editTemplate>
            <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.employeeID" [disabled]="true" /></td>
            <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.employeeName" [disabled]="true" />
            </td>
            <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.proxyID" [disabled]="true" /></td>
            <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.proxyName" [disabled]="true" /></td>
            <td><input type="text" nz-input [(ngModel)]="editCache[data.sid].data.startDate" [disabled]="true" /></td>
            <td><nz-date-picker [(ngModel)]="editCache[data.sid].data.endDate" [nzFormat]="dateFormat"
                [nzDisabledDate]="disabledDate"></nz-date-picker></td>
            <td>
              <a (click)="saveEdit(data.sid)" class="save">{{"Save" | translate}}</a>
              <a nz-popconfirm nzPopconfirmTitle="{{'UneditOrNot'|translate}}" (nzOnConfirm)="cancelEdit(data.sid)"
                style="margin-left:20px;">{{"Cancel" | translate}}</a>
            </td>
          </ng-template>
        </tr>
      </tbody>
    </nz-table>
  </nz-spin>
</nz-card>